/**
 *
 * Asynchronously loads the component for LoginPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SettingsPage = lazyLoad(
  () => import('./index'),
  module => module.SettingsPage,
);
